
import {View} from 'backbone';
import template from 'common-views/dialog.ejs';
import constants from 'Constants.js';
import $ from 'jquery';
import listService from 'ListService.js';

class DialogView extends View {
    initialize(opts){
        super.initialize(opts);
        this._template = template;
        this.validateModel();
        var that = this;
        this.buttons = [
            {
                text: 'OK',
                click: function(){
                    listService.isUndoRedoEnabled = true;
                    if(that.model.has('success')){
                        const success = that.model.get('success');
                        success(that.model);
                    }
                   $(this).dialog( "destroy" ).remove();
                   that.removeModal();
                }
            }
        ];
        const parent = this.model.get('parent');
        $('body').append(this.$el);
    }
    validateModel(){
        const requiredProperties = [
            'text',
            'title'
        ];
        requiredProperties.map(prop => {
            if(! this.model.has(prop)){
                throw "Confirm dialog depends on property '" + prop + "' and it wasn't provided";
            }
        });

    }
    render(){

        return new Promise(resolve => {
            listService.isUndoRedoEnabled = false;
            this.$el.html(this._template(this.model.toJSON()));
            $(constants.DIALOG_ID).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: this.model.get('height') || 225,
                width: this.model.get('width') || 400,
                modal: true,
                resizable: false,
                buttons: this.buttons
            });

            $('div[role="dialog"]').draggable(constants.DEFAULT_DRAGGABLE_OPTIONS);
        });
    }
    removeModal(){
        $( constants.DIALOG_ID ).empty().remove();
    }
}

export default DialogView;